import { PageConfigModel } from "../types/Config";
import { PageConfig } from "../types/strapi/PageConfig";
import { PartnerPageConfig } from "../types/strapi/PartnerPageConfig";

interface MergePageConfigProps {
  pageConfigs: PageConfig[];
  partnerPageConfigs?: PartnerPageConfig[];
  enabledPages?: string[];
}
export function mergePartnerPageConfigWithPageConfig({
  partnerPageConfigs,
  pageConfigs,
  enabledPages,
}: MergePageConfigProps): PageConfigModel[] {
  // merge internal configs
  const configs =
    partnerPageConfigs
      // ?.filter((partnerPageConfig) => partnerPageConfig.isActive)
      ?.filter((p) => p.isActive && p.PageConfig) // check if PageConfig exists
      .map((config) => {
        const pageConfig = config.PageConfig;
        const result: PageConfigModel = {
          pageKey: pageConfig.pageKey,
          order: pageConfig.order || config.order,
          isEnabledPage: pageConfig.isEnabledPage,
          config: {
            ...pageConfig.globalConfig,
            ...config.config,
          },
        };
        return result;
      }) || [];
  // gather all configs
  const pageKeysExisted = configs.map((c) => c.pageKey);
  const theRestGlobalConfig = pageConfigs
    .filter((pageConfig) => !pageKeysExisted.includes(pageConfig.pageKey))
    .map((pageConfig) => ({
      pageKey: pageConfig.pageKey,
      order: pageConfig.order,
      isEnabledPage: pageConfig.isEnabledPage,
      config: pageConfig.globalConfig || {},
    }));
  configs.push(...theRestGlobalConfig);
  // mapped by partner config enabled pages
  const enabledPageConfigs = enabledPages?.length
    ? configs.map((config) => ({
        ...config,
        isEnabledPage: enabledPages.includes(config.pageKey),
      }))
    : configs;
  return enabledPageConfigs;
}
